

export default function MsgComponent(msg) {

    return (
        <span className='d-flex text-danger justify-content-center align-items-center fw-bold error-msg'>{msg.msg}</span>
    )
}